module.exports = __webpack_public_path__ + "static/img/11.8175bd8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/empresas/11.png
// module id = 16UI
// module chunks = 0